module.exports = __webpack_public_path__ + "static/NewJune-semibold-ba4167b2623e212fecd2472595b405ce.woff";